export default __webpack_public_path__ + "static/media/Python.a04c8547.png";